module.exports = __webpack_public_path__ + "static/media/silver.a004c298.png";